// extracted by mini-css-extract-plugin
module.exports = {"MobileNav":"Navbar_MobileNav__173gO","DesktopNav":"Navbar_DesktopNav__1LQM0"};